import React, { useState, useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';

const CommentSection = ({ postId }) => {
    const [formData, setFormData] = useState({ name: '', email: '', content: '' });
    const [msg, setMsg] = useState('');
    const recaptchaRef = useRef();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = recaptchaRef.current.getValue();
        
        if (!token) {
            alert("Please complete the CAPTCHA");
            return;
        }

        try {
            const res = await axios.post('${process.env.REACT_APP_BASE_URL}/backend/api/comments', {
                ...formData,
                post_id: postId,
                recaptcha_token: token
            }, {
                headers: { 'Accept': 'application/json' }
            });
            setMsg(res.data.message);
            setFormData({ name: '', email: '', content: '' });
            recaptchaRef.current.reset();
        } catch (err) {
            alert("Error submitting comment.");
        }
    };

    return (
        <div className="mt-16 p-8 bg-white rounded-3xl shadow-lg border border-gray-100">
            <h3 className="text-2xl font-black text-brand-dark mb-6">Leave a Comment</h3>
            {msg && <div className="p-4 mb-6 bg-green-50 text-green-700 font-bold rounded-xl border border-green-200">{msg}</div>}
            
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <input 
                        type="text" placeholder="Your Name" required
                        className="w-full p-4 rounded-xl border border-gray-200 focus:outline-none focus:border-brand-cyan"
                        value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})}
                    />
                    <input 
                        type="email" placeholder="Your Email" required
                        className="w-full p-4 rounded-xl border border-gray-200 focus:outline-none focus:border-brand-cyan"
                        value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})}
                    />
                </div>
                <textarea 
                    placeholder="Your Comment..." required rows="4"
                    className="w-full p-4 rounded-xl border border-gray-200 focus:outline-none focus:border-brand-cyan resize-none"
                    value={formData.content} onChange={(e) => setFormData({...formData, content: e.target.value})}
                ></textarea>

                <ReCAPTCHA
                    sitekey="6LeBXBctAAAAAAuiq8oAA9rrorh4lUu5_nOwkG7P"
                    ref={recaptchaRef}
                />

                <button type="submit" className="px-8 py-4 bg-brand-dark text-white font-bold rounded-xl hover:bg-brand-cyan hover:text-brand-dark transition-all">
                    Post Comment
                </button>
            </form>
        </div>
    );
};

export default CommentSection;